import { nanoid } from './nanoid'

export function slugify(
  text: string,
  addRandomSuffix: boolean = false,
): string {
  if (!text || typeof text !== 'string') return ''

  // Trim whitespace
  const trimmed = text.trim()
  if (!trimmed) return ''

  // Convert to lowercase and replace spaces/special characters with hyphens
  const slug = trimmed
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters except hyphens
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens

  // Add random suffix if requested and slug is not empty
  if (addRandomSuffix && slug) {
    return `${slug}-${nanoid(5)}`
  }

  return slug
}
